import React, { Fragment } from 'react';
import { advisorView } from 'Context/ViewContext';
import { FamilyDetails as SectionKey } from 'Consts/Questionnaire';
import BoolInput from '../Fields/BoolInput';
import TextInput from '../Fields/TextInput';
import Section from '../Section';
import TextareaInput from '../Fields/TextareaInput';
import USStateInput from '../Fields/USStateInput';

const FamilyDetails = () => (
  <Section
    requiredView={advisorView}
    transitionSpeed={0.25}
    height={400}
    title="Family Details"
    sectionKey={SectionKey}
  >
    <TextareaInput
      placeholder="Family details"
      name="clientFamilyDetails"
      answerKey="clientFamilyDetails"
      maxLength={4000}
      minRows={5}
    />
    <BoolInput
      requiredView={advisorView}
      label="Are you, your significant other, or any member of your immediate family, including parents, in-laws, siblings, and dependents, and any personal or business associates a senior political figure (SPF)?"
      name="hasSPF"
      answerKey="hasSPF"
      checkedChildren={
        <Fragment>
          <TextInput
            placeholder="SPF name"
            name="spfName"
            answerKey="spfName"
          />
          <TextInput
            placeholder="SPF political title"
            name="spfTitle"
            answerKey="spfTitle"
          />
          <TextInput
            placeholder="SPF relationship to account owner"
            name="spfRelationship"
            answerKey="spfRelationship"
          />
          <TextInput
            placeholder="SPF country of office"
            name="spfCountry"
            answerKey="spfCountry"
          />
        </Fragment>
      }
    />
    <BoolInput
      requiredView={advisorView}
      label="Are you, your spouse, or any member of your immediate family, including parents, in-laws, siblings, and dependents, a director, 10% shareholder, or policy-making officer of a publicly traded company?"
      name="holdsShares"
      answerKey="householdHasShareholder"
      checkedChildren={
        <Fragment>
          <TextInput
            placeholder="Company name"
            name="shareholderCompanyName"
            answerKey="householdShareholderCompanyName"
          />
          <TextInput
            placeholder="Company address"
            name="householdShareholderCompanyAddress"
            answerKey="householdShareholderCompanyAddress"
          />
          <TextInput
            placeholder="Company city"
            name="householdShareholderCompanyCity"
            answerKey="householdShareholderCompanyCity"
          />
          <USStateInput
            label="Company state"
            name="householdShareholderCompanyCity"
            answerKey="householdShareholderCompanyState"
          />
        </Fragment>
      }
    />
    <BoolInput
      requiredView={advisorView}
      label="Are you, your spouse, or any member of your immediate family, including parents, in-laws, siblings, and dependents, licensed, employed by, or associated with, a broker-dealer firm, a financial services regulator, securities exchange, or member of a securities exchange?"
      name="holdsShares"
      answerKey="householdIsAssociatedWithFinancialEntity"
      checkedChildren={
        <TextInput
          placeholder="Entity"
          name="associatedFinancialEntity"
          answerKey="householdAssociatedFinancialEntity"
        />
      }
    />
  </Section>
);

export default FamilyDetails;
